module.exports = require("./lib/react-router-scroll-top");